import { resource } from "@assistant-ui/tap";
import { tapSubscribable } from "../util-hooks/tapSubscribable.js";
export const AttachmentRuntimeClient = resource(({ runtime }) => {
    const state = tapSubscribable(runtime);
    return {
        state,
        methods: {
            getState: () => state,
            remove: runtime.remove,
            __internal_getRuntime: () => runtime,
        },
    };
});
//# sourceMappingURL=AttachmentRuntimeClient.js.map